// Shiro Security Brand Assets
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_shirosoc/artifacts/pd8v0wah_image%20%285%29.png";

export const BRAND = {
    name: "Shiro Security",
    tagline: "AI Security. Zero Human Intervention.",
    slogan: "The 3-Layer Defense for Modern Apps.",
    subSlogan: "Automated. AI-Driven. Self-Service Security.",
    website: "shirosec.com",
    email: {
        support: "support@shirosec.com",
        sales: "sales@shirosec.com",
        security: "security@shirosec.com",
        legal: "legal@shirosec.com",
        privacy: "privacy@shirosec.com"
    }
};
